





























































import { Draggable } from 'vue-smooth-dnd'
import Group from '@/types/Group.interface'
import GroupSelector from '@/components/GroupSelector.vue'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    components: { Draggable, GroupSelector },
    props: {
        color: {
            type: String,
            required: true
        },
        colors: {
            type: Array,
            required: true
        },
        disableActions: {
            type: Boolean,
            default: false
        },
        disableDrag: {
            type: Boolean,
            default: false
        },
        displayPicker: {
            type: Boolean,
            default: false
        },
        group: {
            type: Object as PropType<Group>,
            default: null
        },
        idx: {
            type: Number,
            default: 0
        },
        pickerColor: {
            type: String,
            default: '#6142B0'
        }
    },
    computed: {
        tempPickerColor: {
            get(): string {
                return this.pickerColor
            },
            set(val: string): void {
                this.$emit('setColorBuffer', val)
            }
        }
    },
    methods: {
        closePickerBuffer(event: Event, index: number): void {
            //  Create the payload
            const payload = {
                event: event,
                index: index
            }

            //  Emit the event to the parent
            this.$emit('closePickerBuffer', payload)
        }
    }
})
